import React from 'react';
import styled, { css } from 'styled-components';

const DetailsStyled = styled.details.attrs({
  className: 'component__details',
})`
  ${props => {
    const { theme = {}, darkMode = false } = props;
    const { colors = {}, fonts = {}, media = {} } = theme;
    return css`
      &:last-child {
        summary {
          border-bottom: 2px solid #cecece;
        }
      }

      &[open] {
        summary {
          border-bottom: 2px solid #cecece;
        }
      }
      
      summary {
        padding: 4px 0;
        border-top: 2px solid #cecece;
        cursor: pointer;
        background-color: #f7f7f7;
      }

      .details__contents {
        padding-left: 20px;
      }
    `;
  }}
`;

const Details = ({ summary, children, open }) => (
  <DetailsStyled open={open}>
    <summary>{summary}</summary>
    <div className="details__contents">{children}</div>
  </DetailsStyled>
)

export default Details;
